import React, { useState, useEffect, useRef } from 'react';
import { gql, useQuery, useLazyQuery, useMutation } from '@apollo/client';
import { makeStyles } from '@material-ui/core/styles';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { useParams } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import {
  GET_CARDHOLDERS,
  GET_CARDHOLDERSFIELDS,
  GET_USER_CONFIG,
  GET_USER_CONFIG_ID,
  ADD_USER_CONFIG,
  UPDATE_USER_CONFIG,
  REMOVE_USER_CONFIG,
} from '../util/schema';
import getNameFromToken from '../util/jwtToken';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import { Button, ListItemText } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  content: {
    display: 'flex',
    flexWrap: 'wrap',
    maxWidth: '100%',
    minHeight: '300px',
  },
  listItemText: {
    //. marginRight: theme.spacing(1),
  },
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));

const UserConfigSettings = ({ apiToken, setColorTheme }) => {
  const classes = useStyles();
  const params = useParams();
  const [userName, setuserName] = useState('Administrator');
  const [UserID, setUserID] = useState(1);
  const [userConfigInput, setuserConfigInput] = useState();
  const [newDataFlag, setnewDataFlag] = useState(false);
  const [userConfigSettings, setUserConfigSettings] = useState([]);
  const [queryFilters, setQueryFilters] = useState([]);
  const [darkmode, setDarkmode] = useState(false);

  const queryUserConfig = (data) => {
    if (data == null) {
      setnewDataFlag(true);
    } else {
      setUserID(data.userConfigData.User_ID);
      setnewDataFlag(false);
      const obj = JSON.parse(data.userConfigData.Settings);
      setUserConfigSettings(Object.entries(obj.Value));
      if (obj.Value.filters) {
        try {
          const filters = JSON.parse(obj.Value.filters);
          setQueryFilters(filters);
        } catch (err) {
          console.log('error', err);
        }
      }
      if (obj.Value.darkmode) {
        try {
          const thismode = JSON.parse(obj.Value.darkmode);
          setDarkmode(thismode);
        } catch (err) {
          console.log('error', err);
        }
      }
      return obj;
    }
  };

  useEffect(() => {
    let ClientName = getNameFromToken(apiToken);
    setuserName(ClientName);
    fetchUserConfig();
  }, []);

  const queryErrorUserConfig = ({ graphQLErrors, networkError }) => {
    console.log(graphQLErrors);
    console.log(networkError);
    setnewDataFlag(true);
  };

  const [
    fetchUserConfig,
    { data: userData, loading: userDataLoading, error: userDataError, fetchMore },
  ] = useLazyQuery(GET_USER_CONFIG, {
    variables: { userconfigName: userName },
    notifyOnNetworkStatusChange: true,
    onCompleted: queryUserConfig,
    onError: queryErrorUserConfig,
  });
  const [
    removeUserConfig,
    { data: userDataRemove, loading: userDataloadingR, error: userDataErrorR },
  ] = useMutation(REMOVE_USER_CONFIG, {
    notifyOnNetworkStatusChange: true,
    onError: queryErrorUserConfig,
  });

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  const handleRemove = (e) => {
    removeUserConfig({ variables: { userconfigID: UserID } });
    setColorTheme('light');
    window.location.reload();
  };

  return (
    <>
      <Typography variant="h5">User Configuration Settings</Typography>
      <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
        <Link color="inherit" href="/admin">
          Administration
        </Link>
        <Link color="inherit" href="/globalSettings/globalSetting">
          Global Settings
        </Link>
        <Typography color="textPrimary">User Configuration Settings</Typography>
      </Breadcrumbs>

      <div className={classes.root}>
        <Typography color="initial" style={{ padding: '1%' }} variant="h6">
          User Configuration Data:
        </Typography>
        <Paper className={classes.content}>
          <Grid container style={{ display: 'flex' }} spacing={1}>
            <Grid
              item
              xs={6}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'row',
                flexWrap: 'wrap',
              }}
            >
              {userConfigSettings.map((e) => {
                let thisstring = capitalizeFirstLetter(e[0]);
                return (
                  <>
                    <ListItem style={{ justifyContent: 'center' }}>
                      <Typography variant="h5">{thisstring} : </Typography>
                    </ListItem>
                  </>
                );
              })}
            </Grid>
            <Grid
              item
              xs={6}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'row',
                flexWrap: 'wrap',
              }}
            >
              {userConfigSettings.map((e) => {
                let setting = JSON.parse(e[1]);
                if (typeof setting == 'boolean') {
                  setting = setting ? 'active' : 'disabled';
                  if (typeof setting == 'string') {
                  }
                } else {
                  let Filters = [];
                  setting.forEach((element) => {
                    Filters.push({ [element.id]: element.filter });
                  });
                  setting = Filters;
                  let final = [];
                  setting.forEach((element) => {
                    let keys = capitalizeFirstLetter(Object.keys(element).toString());
                    let vals = Object.values(element);
                    final.push(keys + ': ' + vals + ', ');
                  });
                  setting = final;
                }
                return (
                  <>
                    <ListItem style={{ justifyContent: 'center' }}>
                      <Typography variant="h6">{setting}</Typography>
                    </ListItem>
                  </>
                );
              })}
            </Grid>
          </Grid>
          {!newDataFlag && (
            <Button
              variant="contained"
              size="small"
              color="default"
              style={{ margin: 'auto' }}
              onClick={handleRemove}
            >
              Remove User Configuration
            </Button>
          )}
          {newDataFlag && (
            <div>
              <Typography variant="h5">No User Configuration Data</Typography>
            </div>
          )}
        </Paper>
      </div>
    </>
  );
};

export default UserConfigSettings;
